import React from 'react'
import NavbarComponent from '../components/navbar-component/navbar-component'
import { Breadcrumb } from 'rsuite'
import IframeComponent from '../components/dynamic-iframe-component/common-iframe'
import { Link, useNavigate } from 'react-router-dom'
import useServices from '../hooks/useServices'
import './apply-application-page.css'

export default function ApplyApplicationPage() {
  const [services] = useServices();
  const navigate = useNavigate();

  return (
    <div className="apply-application-page">
      <NavbarComponent />
      <div className="container">
        <div>
          <Breadcrumb separator={">"}>
            <Breadcrumb.Item as={Link} onClick={() => navigate('/home')} href="#">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item as={Link}>Aplication</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <div className="apply-application-page__embed">
        <IframeComponent iframeSrc={services.iFarameURL} fillViewport />
      </div>
    </div>
  )
}
